export default {"src":"/_next/static/image/public/icons/control/chevron-left.bbf86ae99b025baaf61efe8230c5687b.svg","height":19,"width":11};